module.exports = __webpack_public_path__ + "img/Skirt-Back-B9-Fb.995021b0.png";